<template>
  <Teleport to="body">
    <div v-if="modelValue" class="modal-backdrop-layout" :style="{ zIndex: zIndexEfetivo }" @click.self="fechar">
      <div class="modal-card-layout shadow" :class="tamanhoClass">
        <header class="modal-header-layout">
          <h5 class="mb-0">
            <i class="bi bi-layout-three-columns me-2"></i>
            Gerenciar Layouts — {{ modulo }}
          </h5>
          <button type="button" class="btn-close" @click="fechar"></button>
        </header>

        <div class="modal-body-layout">
          <!-- Estado: Lista de layouts -->
          <template v-if="!modoEdicao && !modoCompartilhar">
            <!-- Botão novo layout -->
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span class="text-muted small">{{ layouts.length }} padrão(ões) salvo(s)</span>
              <button class="btn btn-sm btn-primary" @click="iniciarCriacao">
                <i class="bi bi-plus-lg me-1"></i> Novo Padrão
              </button>
            </div>

            <!-- Lista de layouts -->
            <div v-if="carregando" class="text-center py-4">
              <div class="spinner-border spinner-border-sm text-primary"></div>
            </div>
            <div v-else-if="layouts.length === 0" class="text-center py-5 text-muted">
              <i class="bi bi-layout-three-columns fs-1 d-block mb-2"></i>
              <p class="mb-0">Nenhum padrão salvo ainda.</p>
              <small>Personalize as colunas e clique em "Novo Padrão" para salvar.</small>
            </div>
            <div v-else class="lista-layouts">
              <div
                v-for="layout in layouts"
                :key="layout.idUserGridLayout"
                class="card-layout-item"
                :class="{ 'card-layout-default': layout.isDefault }"
              >
                <div class="layout-info">
                  <div class="layout-nome">
                    <strong>{{ layout.nome }}</strong>
                    <span v-if="layout.isDefault" class="badge bg-warning text-dark ms-2">Default</span>
                  </div>
                  <div class="layout-descricao text-muted small" v-if="layout.descricao">
                    {{ layout.descricao }}
                  </div>
                  <div class="layout-meta text-muted small">
                    <span>Criado {{ formatarData(layout.tsCriacao) }}</span>
                    <span v-if="layout.compartilhadosCom?.length" class="ms-2">
                      <i class="bi bi-people-fill"></i> {{ layout.compartilhadosCom.length }} compartilhado(s)
                    </span>
                  </div>
                </div>
                <div class="layout-acoes">
                  <button class="btn btn-sm btn-outline-primary" @click="aplicarLayout(layout)" title="Aplicar este layout">
                    <i class="bi bi-check2-square"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-success" @click="atualizarLayoutComConfigAtual(layout)" title="Substituir pela configuração atual da tabela">
                    <i class="bi bi-arrow-repeat"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-secondary" @click="iniciarEdicao(layout)" title="Editar nome/descrição">
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-secondary" @click="iniciarCompartilhar(layout)" title="Compartilhar">
                    <i class="bi bi-share"></i>
                  </button>
                  <button
                    class="btn btn-sm"
                    :class="layout.isDefault ? 'btn-warning' : 'btn-outline-warning'"
                    @click="alternarDefault(layout)"
                    :title="layout.isDefault ? 'Remover como padrão' : 'Definir como padrão'"
                  >
                    <i :class="layout.isDefault ? 'bi bi-star-fill' : 'bi bi-star'"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-danger" @click="excluirLayout(layout)" title="Excluir">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </template>

          <!-- Estado: Edição/Criação -->
          <template v-if="modoEdicao">
            <div class="mb-3">
              <label class="form-label fw-semibold">Nome do Padrão <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="formEdit.nome"
                placeholder="Ex: Meu Layout Completo"
                maxlength="200"
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Descrição</label>
              <textarea
                class="form-control"
                v-model="formEdit.descricao"
                placeholder="Descreva o propósito deste padrão (opcional)"
                rows="2"
                maxlength="500"
              ></textarea>
            </div>
            <div class="d-flex gap-2 justify-content-end">
              <button class="btn btn-outline-secondary" @click="cancelarEdicao">Cancelar</button>
              <button class="btn btn-primary" @click="salvarLayout" :disabled="!formEdit.nome.trim()">
                <i class="bi bi-check-lg me-1"></i> Salvar
              </button>
            </div>
          </template>

          <!-- Estado: Compartilhar -->
          <template v-if="modoCompartilhar">
            <div class="mb-3">
              <p class="mb-1"><strong>Compartilhar:</strong> {{ layoutCompartilhar?.nome }}</p>
              <p class="text-muted small mb-0">Selecione os usuários da empresa para compartilhar este layout.</p>
            </div>

            <div class="mb-3">
              <label class="form-label fw-semibold">Opção de Compartilhamento</label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="compartilhar-ref"
                  v-model="formCompartilhar.isCopia"
                  :value="false"
                />
                <label class="form-check-label" for="compartilhar-ref">
                  Compartilhar o mesmo layout (alterações refletem para todos)
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="compartilhar-copia"
                  v-model="formCompartilhar.isCopia"
                  :value="true"
                />
                <label class="form-check-label" for="compartilhar-copia">
                  Criar cópia independente para cada usuário
                </label>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label fw-semibold">Usuários</label>
              <CampoBuscaMultiplo
                id="compartilhar-usuarios"
                label="Buscar usuários"
                :configuracao-busca="configBuscaUsuarios"
                v-model="formCompartilhar.idsUsuarios"
                @selecionados="onUsuariosSelecionados"
                hide-label
              />
            </div>

            <div v-if="layoutCompartilharCompartilhados.length > 0" class="mb-3">
              <label class="form-label fw-semibold">Já compartilhado com</label>
              <div v-for="c in layoutCompartilharCompartilhados" :key="c.idCompartilhamento" class="d-flex align-items-center gap-2 mb-1">
                <span class="small">{{ c.nomeUsuario }}</span>
                <span v-if="c.isCopia" class="badge bg-info bg-opacity-10 text-info border border-info-subtle">Cópia</span>
                <button class="btn btn-sm btn-link text-danger p-0" @click="removerCompartilhamento(c)" title="Remover compartilhamento">
                  <i class="bi bi-x-circle"></i>
                </button>
              </div>
            </div>

            <div class="d-flex gap-2 justify-content-end">
              <button class="btn btn-outline-secondary" @click="cancelarCompartilhar">Cancelar</button>
              <button
                class="btn btn-primary"
                @click="confirmarCompartilhar"
                :disabled="formCompartilhar.idsUsuarios.length === 0"
              >
                <i class="bi bi-share me-1"></i> Compartilhar
              </button>
            </div>
          </template>
        </div>

        <footer class="modal-footer-layout">
          <span class="text-muted small">
            Defina um layout como <strong>Default</strong> para que ele seja aplicado automaticamente ao abrir esta tela.
          </span>
        </footer>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, reactive, computed, watch, onUnmounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { layoutService } from '@/services/layoutService'
import CampoBuscaMultiplo from '../campos/CampoBuscaMultiplo.vue'
import { reservarZIndex, liberarZIndex, BASE_ZINDEX } from '@/composables/useZIndex'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  modulo: { type: String, required: true },
  colunasDisponiveis: { type: Array, default: null },
  layoutAtual: { type: Object, default: () => ({ colunas: [], sortField: '', sortOrder: '' }) }
})

const emit = defineEmits(['update:modelValue', 'aplicar-layout', 'show-notification'])

// --- Empilhamento (z-index) via registry central ---
const tokenZIndex = ref(null)
const zIndexReservado = ref(null)
const zIndexEfetivo = computed(() => zIndexReservado.value ?? BASE_ZINDEX)

// ============================================================
// Estado
// ============================================================
const layouts = ref([])
const carregando = ref(false)

const modoEdicao = ref(false)
const modoCompartilhar = ref(false)

const formEdit = reactive({
  id: null,
  nome: '',
  descricao: ''
})

const layoutCompartilhar = ref(null)
const layoutCompartilharCompartilhados = ref([])
const formCompartilhar = reactive({
  isCopia: false,
  idsUsuarios: []
})

// Configuração de busca de usuários da empresa (CampoBuscaMultiplo)
// Filtra por idEmpresa para mostrar apenas usuários da empresa ativa
const configBuscaUsuarios = computed(() => {
  const authStore = useAuthStore()
  const filtros = { statusUsuario: 'Ativo' }
  if (authStore.empresaAtiva) {
    filtros.idEmpresa = authStore.empresaAtiva
  }
  return {
    endpointApi: 'Usuarios',
    idField: 'idUsuario',
    descField: 'nome',
    displayField: 'nome',
    label: 'Buscar usuários',
    placeholder: 'Nome ou e-mail...',
    colunasGrid: [
      { dataField: 'nome', header: 'Nome', width: 200 },
      { dataField: 'email', header: 'E-mail', width: 250 }
    ],
    filtrosFixos: filtros
  }
})

const tamanhoClass = computed(() => 'modal-xl')

// CampoBuscaMultiplo emite 'selecionados' com os itens completos.
// Mantém formCompartilhar.idsUsuarios sincronizado (já feito via v-model).
const onUsuariosSelecionados = () => {
  // O v-model já atualiza formCompartilhar.idsUsuarios com os IDs
  // Este handler existe apenas para futuras validações, se necessário.
}

// ============================================================
// Carregar layouts
// ============================================================
async function carregarLayouts () {
  carregando.value = true
  try {
    const { data } = await layoutService.listar(props.modulo)
    // Carregar compartilhados de cada layout
    const itens = Array.isArray(data) ? data : []
    for (const item of itens) {
      try {
        const detalhes = await layoutService.getById(item.idUserGridLayout)
        item.compartilhadosCom = detalhes.data?.compartilhadosCom || []
      } catch {
        item.compartilhadosCom = []
      }
    }
    layouts.value = itens
  } catch (e) {
    console.error('[GerenciadorLayout] Erro ao carregar layouts:', e)
    const msg = e?.response?.data?.message || ''
    if (msg.includes('Empresa não identificada')) {
      emit('show-notification', {
        message: 'Selecione uma empresa no topo da tela antes de gerenciar layouts.',
        type: 'warning'
      })
    } else {
      emit('show-notification', { message: 'Erro ao carregar layouts.', type: 'error' })
    }
  } finally {
    carregando.value = false
  }
}

// ============================================================
// Aplicar layout
// ============================================================
function aplicarLayout (layout) {
  let colunas = []
  try {
    colunas = JSON.parse(layout.configuracaoColunas || '[]')
  } catch {
    colunas = []
  }
  emit('aplicar-layout', {
    colunas,
    sortField: layout.sortField,
    sortOrder: layout.sortOrder
  })
  emit('show-notification', { message: `Layout "${layout.nome}" aplicado.`, type: 'success' })
  fechar()
}

// ============================================================
// Criar / Editar
// ============================================================
function iniciarCriacao () {
  formEdit.id = null
  formEdit.nome = ''
  formEdit.descricao = ''
  modoEdicao.value = true
}

function iniciarEdicao (layout) {
  formEdit.id = layout.idUserGridLayout
  formEdit.nome = layout.nome
  formEdit.descricao = layout.descricao || ''
  modoEdicao.value = true
}

function cancelarEdicao () {
  modoEdicao.value = false
  formEdit.id = null
  formEdit.nome = ''
  formEdit.descricao = ''
}

async function salvarLayout () {
  if (!formEdit.nome.trim()) return

  // Usa as colunas atuais do snapshot (que reflete o estado atual da tabela,
  // incluindo larguras alteradas pelo redimensionamento)
  const configuracaoColunas = JSON.stringify(
    (props.layoutAtual?.colunas || []).map((c, idx) => ({
      field: c.field,
      label: c.label,
      width: c.width || null,
      order: idx,
      visible: c.visible !== false,
      sortable: c.sortable !== false,
      align: c.align || 'left'
    }))
  )

  // Preserva isDefault do layout original se for edição
  const layoutOriginal = formEdit.id
    ? layouts.value.find(l => l.idUserGridLayout === formEdit.id)
    : null

  const payload = {
    modulo: props.modulo,
    nome: formEdit.nome.trim(),
    descricao: formEdit.descricao.trim() || null,
    isDefault: layoutOriginal ? layoutOriginal.isDefault : false,
    configuracaoColunas,
    sortField: props.layoutAtual?.sortField || '',
    sortOrder: props.layoutAtual?.sortOrder || ''
  }

  try {
    if (formEdit.id) {
      await layoutService.atualizar(formEdit.id, payload)
      emit('show-notification', { message: 'Layout atualizado com sucesso!', type: 'success' })
    } else {
      await layoutService.criar(payload)
      emit('show-notification', { message: 'Layout salvo com sucesso!', type: 'success' })
    }
    cancelarEdicao()
    await carregarLayouts()
  } catch (e) {
    const msg = e?.response?.data?.message || ''
    if (msg.includes('Empresa não identificada')) {
      emit('show-notification', {
        message: 'Selecione uma empresa no topo da tela antes de salvar layouts.',
        type: 'warning'
      })
    } else {
      emit('show-notification', { message: 'Erro ao salvar layout.', type: 'error' })
    }
  }
}

// ============================================================
// Default (favoritar / desfavoritar)
// ============================================================
async function alternarDefault (layout) {
  if (layout.isDefault) {
    await removerDefault(layout)
  } else {
    await definirDefault(layout)
  }
}

async function definirDefault (layout) {
  try {
    await layoutService.setDefault(layout.idUserGridLayout)
    emit('show-notification', { message: `Layout "${layout.nome}" definido como padrão.`, type: 'success' })
    await carregarLayouts()
  } catch (e) {
    const msg = extrairMensagemErro(e, 'Erro ao definir layout como padrão.')
    emit('show-notification', { message: msg, type: 'error' })
  }
}

async function removerDefault (layout) {
  try {
    await layoutService.atualizar(layout.idUserGridLayout, {
      modulo: layout.modulo || props.modulo,
      nome: layout.nome,
      descricao: layout.descricao || null,
      isDefault: false,
      configuracaoColunas: layout.configuracaoColunas || '[]',
      sortField: layout.sortField || '',
      sortOrder: layout.sortOrder || ''
    })
    emit('show-notification', { message: `Layout "${layout.nome}" removido como padrão.`, type: 'success' })
    await carregarLayouts()
  } catch (e) {
    const msg = extrairMensagemErro(e, 'Erro ao remover layout como padrão.')
    emit('show-notification', { message: msg, type: 'error' })
  }
}

// Extrai mensagem de erro do backend seguindo a hierarquia padrão
function extrairMensagemErro (e, fallback) {
  const data = e?.response?.data
  if (typeof data === 'string') return data
  if (data?.message) return data.message
  if (data?.title) return data.title
  if (data?.errors) return Object.values(data.errors).flat().join('; ')
  return fallback
}

// ============================================================
// Atualizar layout com a configuração atual da tabela
// ============================================================
async function atualizarLayoutComConfigAtual (layout) {
  const configuracaoColunas = JSON.stringify(
    (props.layoutAtual?.colunas || []).map((c, idx) => ({
      field: c.field,
      label: c.label,
      width: c.width || null,
      order: idx,
      visible: c.visible !== false,
      sortable: c.sortable !== false,
      align: c.align || 'left'
    }))
  )

  const payload = {
    modulo: props.modulo,
    nome: layout.nome,
    descricao: layout.descricao || null,
    isDefault: layout.isDefault,
    configuracaoColunas,
    sortField: props.layoutAtual?.sortField || layout.sortField || '',
    sortOrder: props.layoutAtual?.sortOrder || layout.sortOrder || ''
  }

  try {
    await layoutService.atualizar(layout.idUserGridLayout, payload)
    emit('show-notification', { message: `Layout "${layout.nome}" atualizado com a configuração atual.`, type: 'success' })
    await carregarLayouts()
  } catch (e) {
    const msg = e?.response?.data?.message || ''
    if (msg.includes('Empresa não identificada')) {
      emit('show-notification', {
        message: 'Selecione uma empresa no topo da tela antes de atualizar layouts.',
        type: 'warning'
      })
    } else {
      emit('show-notification', { message: 'Erro ao atualizar layout.', type: 'error' })
    }
  }
}

// ============================================================
// Excluir
// ============================================================
async function excluirLayout (layout) {
  try {
    await layoutService.excluir(layout.idUserGridLayout)
    emit('show-notification', { message: 'Layout excluído.', type: 'success' })
    await carregarLayouts()
  } catch (e) {
    emit('show-notification', { message: 'Erro ao excluir layout.', type: 'error' })
  }
}

// ============================================================
// Compartilhar
// ============================================================
async function iniciarCompartilhar (layout) {
  layoutCompartilhar.value = layout
  formCompartilhar.isCopia = false
  formCompartilhar.idsUsuarios = []
  modoCompartilhar.value = true

  try {
    const { data } = await layoutService.listarCompartilhados(layout.idUserGridLayout)
    layoutCompartilharCompartilhados.value = Array.isArray(data) ? data : []
  } catch {
    layoutCompartilharCompartilhados.value = []
  }
}

function cancelarCompartilhar () {
  modoCompartilhar.value = false
  layoutCompartilhar.value = null
  layoutCompartilharCompartilhados.value = []
  formCompartilhar.isCopia = false
  formCompartilhar.idsUsuarios = []
}

async function confirmarCompartilhar () {
  if (!layoutCompartilhar.value || formCompartilhar.idsUsuarios.length === 0) return
  try {
    await layoutService.compartilhar({
      idUserGridLayout: layoutCompartilhar.value.idUserGridLayout,
      idsUsuarios: formCompartilhar.idsUsuarios,
      isCopia: formCompartilhar.isCopia
    })
    emit('show-notification', { message: 'Layout compartilhado com sucesso!', type: 'success' })
    cancelarCompartilhar()
    await carregarLayouts()
  } catch (e) {
    emit('show-notification', { message: 'Erro ao compartilhar layout.', type: 'error' })
  }
}

async function removerCompartilhamento (c) {
  if (!confirm(`Remover compartilhamento com ${c.nomeUsuario}?`)) return
  try {
    await layoutService.removerCompartilhamento(c.idCompartilhamento)
    emit('show-notification', { message: 'Compartilhamento removido.', type: 'success' })
    if (layoutCompartilhar.value) {
      const { data } = await layoutService.listarCompartilhados(layoutCompartilhar.value.idUserGridLayout)
      layoutCompartilharCompartilhados.value = Array.isArray(data) ? data : []
    }
    await carregarLayouts()
  } catch (e) {
    emit('show-notification', { message: 'Erro ao remover compartilhamento.', type: 'error' })
  }
}

// ============================================================
// Utilitários
// ============================================================
function formatarData (data) {
  if (!data) return '-'
  return new Date(data).toLocaleDateString('pt-BR')
}

function fechar () {
  emit('update:modelValue', false)
  cancelarEdicao()
  cancelarCompartilhar()
}

// ============================================================
// Carregar ao abrir
// ============================================================
watch(() => props.modelValue, (aberto) => {
  if (aberto) {
    const { token, zIndex } = reservarZIndex()
    tokenZIndex.value = token
    zIndexReservado.value = zIndex
    carregarLayouts()
  } else {
    liberarZIndex(tokenZIndex.value)
    tokenZIndex.value = null
    zIndexReservado.value = null
  }
})

onUnmounted(() => {
  liberarZIndex(tokenZIndex.value)
  tokenZIndex.value = null
  zIndexReservado.value = null
})
</script>

<style scoped>
/* ============================================================
   GerenciadorLayoutModal — Estilos
   ============================================================ */

.modal-backdrop-layout {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  overflow-y: auto;
}

.modal-card-layout {
  background: var(--bs-body-bg, #fff);
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
}

.modal-header-layout {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background-color: #34495E;
  color: #FFFFFF;
  border-radius: 0.5rem 0.5rem 0 0;
}

.modal-body-layout {
  flex: 1;
  overflow-y: auto;
  padding: 1.5rem;
}

.modal-footer-layout {
  padding: 0.75rem 1.5rem;
  border-top: 1px solid var(--bs-border-color, #dee2e6);
  background-color: var(--bs-tertiary-bg, #f8f9fa);
  border-radius: 0 0 0.5rem 0.5rem;
}

/* ============================================================
   Cards de Layout
   ============================================================ */
.lista-layouts {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.card-layout-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 0.5rem;
  background-color: var(--bs-secondary-bg, #fff);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  gap: 1rem;
}

.card-layout-item:hover {
  border-color: var(--bs-primary, #0d6efd);
  box-shadow: 0 0 0 1px var(--bs-primary, #0d6efd);
}

.card-layout-default {
  border-left: 4px solid var(--bs-warning, #ffc107);
  background-color: var(--bs-warning-bg-subtle, #fff3cd);
}

.layout-info {
  flex: 1;
  min-width: 0;
}

.layout-nome {
  font-size: 0.95rem;
  margin-bottom: 0.15rem;
}

.layout-descricao {
  font-size: 0.8rem;
  margin-bottom: 0.15rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.layout-meta {
  font-size: 0.75rem;
}

.layout-acoes {
  display: flex;
  gap: 0.35rem;
  flex-shrink: 0;
}

.layout-acoes .btn {
  font-size: 0.75rem;
  padding: 0.2rem 0.4rem;
  line-height: 1;
}

/* ============================================================
   Lista de Usuários
   ============================================================ */
.lista-usuarios {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 0.375rem;
  padding: 0.5rem 0.75rem;
}

.lista-usuarios .form-check {
  margin-bottom: 0.25rem;
}

/* ============================================================
   Responsivo
   ============================================================ */
@media (max-width: 767.98px) {
  .modal-card-layout {
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }

  .card-layout-item {
    flex-direction: column;
    align-items: stretch;
  }

  .layout-acoes {
    justify-content: flex-end;
    margin-top: 0.5rem;
  }

  .modal-backdrop-layout {
    padding: 0;
    align-items: stretch;
  }
}
</style>
